// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Invoices.css — responsive overrides for src/pages/Invoices.jsx
 * Loads AFTER index.css (imported as first CSS in Invoices.jsx) so wins at equal specificity.
 *
 * Breakpoints (project standard — do not invent others):
 *   mobile  : max-width  576px
 *   tablet  : 577px – 991px
 *   laptop  : 992px – 1280px
 *   desktop : min-width 1281px
 *
 * Desktop behaviour is UNCHANGED — all rules live inside max-width media queries.
 */

/* Mobile card list is always hidden unless we are on mobile.
   The table is always visible on tablet+. */
.invoices-page .invoice-cards-mobile {
  display: none;
}

/* ===========================================================================
 * LAPTOP (≤1280px): drawer full-width, hide preview pane
 * ======================================================================== */
@media (max-width: 1280px) {
  /* Drawer already collapses at 1024px in inline styles; reinforce here */
  .invoices-page .invoice-drawer {
    width: 100%;
  }

  .invoices-page .drawer-preview {
    display: block;
    width: 100%;
  }
}

/* ===========================================================================
 * TABLET (577px – 991px): gentle reflow
 * ======================================================================== */
@media (max-width: 991px) {
  /* Stats row: 3 columns on tablet */
  .invoices-page .stats-row {
    grid-template-columns: repeat(3, 1fr);
  }

  /* Drawer header: allow wrap */
  .invoices-page .drawer-header {
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .invoices-page .drawer-header-right {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
}

/* ===========================================================================
 * MOBILE (≤576px): full app-like treatment
 * ======================================================================== */
@media (max-width: 576px) {
  .invoices-page .drawer-preview{
    overflow: scroll;
  }
  .drawer-content{
    display: inline-block;
    overflow: scroll;
  }

  /* ── Page wrapper ───────────────────────────────────────────────────────── */
  .invoices-page {
    min-width: 0;
    overflow-x: hidden;
  }

  /* ── Page header: stack title + button ──────────────────────────────────── */
  .invoices-page .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .invoices-page .page-header h1 {
    font-size: 1.25rem;
  }

  .invoices-page .page-header .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
    padding: 0.625rem 1rem;
  }

  /* ── Stats row: 2 columns on mobile ────────────────────────────────────── */
  .invoices-page .stats-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.625rem;
    margin-bottom: 1rem;
  }

  .invoices-page .stat-item {
    padding: 0.875rem 1rem;
  }

  .invoices-page .stat-value {
    font-size: 1.25rem;
  }

  /* ── Table toolbar: wrap, full-width search ─────────────────────────────── */
  .invoices-page .table-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 0.625rem;
    margin-bottom: 0.75rem;
  }

  .invoices-page .search-box {
    max-width: 100%;
    width: 100%;
  }

  .invoices-page .search-box input {
    width: 100%;
    min-height: 44px;
    box-sizing: border-box;
  }

  .invoices-page .toolbar-actions {
    flex-wrap: wrap;
    gap: 0.5rem;
    width: 100%;
  }

  .invoices-page .btn-toolbar {
    min-height: 44px;
    flex: 1 1;
    justify-content: center;
  }

  .invoices-page .btn-clear-filters {
    min-height: 44px;
    width: 100%;
    justify-content: center;
  }

  /* ── Invoices table: hide, show card list ───────────────────────────────── */
  .invoices-page .invoices-table-card {
    background: transparent;
    border: none;
    padding: 0;
  }

  .invoices-page .table-container {
    overflow-x: visible;
  }

  .invoices-page .invoices-data-table {
    display: none;
  }

  /* Card list container — shown on mobile, hidden on larger screens (see base rule above) */
  .invoices-page .invoice-cards-mobile {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  /* Individual invoice card */
  .invoices-page .invoice-card-mobile {
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    padding: 1rem;
    cursor: pointer;
    transition: background-color 0.15s;
    display: flex;
    flex-direction: column;
    gap: 0.625rem;
  }

  .invoices-page .invoice-card-mobile:active {
    background: var(--bg-secondary);
  }

  .invoices-page .invoice-card-mobile-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .invoices-page .invoice-card-mobile-id {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 600;
    font-size: 0.875rem;
    color: var(--text-primary);
    min-width: 0;
  }

  .invoices-page .invoice-card-mobile-id svg {
    flex-shrink: 0;
    color: var(--accent-primary);
  }

  .invoices-page .invoice-card-mobile-amount {
    font-weight: 700;
    font-size: 1rem;
    color: var(--text-primary);
    flex-shrink: 0;
  }

  .invoices-page .invoice-card-mobile-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.8rem;
  }

  .invoices-page .invoice-card-mobile-label {
    font-size: 0.7rem;
    color: var(--text-muted);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    flex-shrink: 0;
  }

  .invoices-page .invoice-card-mobile-value {
    color: var(--text-secondary);
    text-align: right;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .invoices-page .invoice-card-mobile-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.5rem;
    border-top: 1px solid var(--border-color);
    gap: 0.5rem;
  }

  .invoices-page .invoice-card-mobile-actions {
    display: flex;
    gap: 0.5rem;
  }

  .invoices-page .invoice-card-mobile-actions .action-icon-btn {
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Empty / loading states within mobile cards wrapper */
  .invoices-page .invoice-mobile-empty {
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    padding: 3rem 1.5rem;
    text-align: center;
    color: var(--text-muted);
  }

  .invoices-page .invoice-mobile-empty p {
    margin: 0.75rem 0 1rem;
  }

  .invoices-page .invoice-mobile-empty .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* ── Pagination: stack info and controls ─────────────────────────────────── */
  .invoices-page .pagination-container {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    padding: 0.75rem 0;
  }

  .invoices-page .pagination-info {
    flex-wrap: wrap;
    gap: 0.5rem;
    font-size: 0.8rem;
    justify-content: space-between;
  }

  .invoices-page .page-size-select {
    min-height: 44px;
  }

  .invoices-page .pagination-controls {
    flex-wrap: wrap;
    justify-content: center;
    gap: 4px;
  }

  .invoices-page .pagination-btn,
  .invoices-page .page-number {
    min-width: 44px;
    min-height: 44px;
  }

  /* ── Create Invoice Drawer → bottom sheet ────────────────────────────────── */
  .invoices-page .invoice-drawer {
    top: 20px;
    bottom: 0;
    right: 0;
    left: 0;
    width: 90%;
    height: 95vh;
    border-radius: 16px 16px;
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.2);
    animation: invoice-drawer-up 0.3s ease-out;
    padding-bottom: env(safe-area-inset-bottom);
    margin: 0 auto;
  }
  .drawer-header-right .btn-outline {
    width: 100%;
  }

  @keyframes invoice-drawer-up {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }

  /* Drag handle affordance */
  .invoices-page .invoice-drawer::before {
    content: '';
    display: block;
    width: 40px;
    height: 4px;
    background: var(--border-color);
    border-radius: 2px;
    margin: 0.625rem auto 0;
  }

  /* Drawer header: compress + wrap on small screen */
  .invoices-page .drawer-header {
    padding: 0.625rem 1rem;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .invoices-page .drawer-header-left {
    gap: 0.625rem;
    flex: 1 1;
    min-width: 0;
  }

  .invoices-page .drawer-title-section h2 {
    font-size: 0.9rem;
  }

  /* Header right: wrap into second row when needed */
  .invoices-page .drawer-header-right {
    flex-wrap: wrap;
    gap: 0.5rem;
    width: 100%;
  }

  /* Show preview button hidden on mobile (preview pane always hidden) */
  .invoices-page .drawer-header-right .btn-outline:first-of-type {
    display: none;
  }

  /* Maximize button hidden on mobile (not useful for bottom sheet) */
  .invoices-page .btn-icon-outline {
    display: none;
  }

  /* Create Invoice button full-width */
  .invoices-page .drawer-header-right .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* Form scroll padding */
  .invoices-page .form-scroll {
    padding: 1rem;
    padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  }

  /* Section content: reduce left indent on mobile */
  .invoices-page .section-content {
    padding-left: 0;
  }

  /* Form rows: single column */
  .invoices-page .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }

  /* Inputs full-width with proper tap targets */
  .invoices-page .form-group input,
  .invoices-page .form-group select,
  .invoices-page .form-group textarea {
    width: 100%;
    min-height: 44px;
    box-sizing: border-box;
  }

  .invoices-page .form-group textarea {
    min-height: auto;
  }

  /* ── Line items: stack each item as a card ─────────────────────────────── */
  .invoices-page .line-items-header {
    display: none;
  }

  .invoices-page .line-item-row {
    /* Switch from 5-column grid to stacked layout */
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.75rem;
    border-top: 1px solid var(--border-color);
    position: relative;
  }

  .invoices-page .line-item-row input.col-description {
    width: 100%;
    font-size: 0.9rem;
    padding: 0.5rem 2.75rem 0.5rem 0.5rem;
    min-height: 44px;
  }

  .invoices-page .line-item-row .col-qty-wrapper,
  .invoices-page .line-item-row .col-price-wrapper {
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }

  /* Label before qty/price inputs */
  .invoices-page .line-item-row .col-qty-wrapper::before {
    content: 'Qty';
    font-size: 0.7rem;
    color: var(--text-muted);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    white-space: nowrap;
    min-width: 2.5rem;
  }

  .invoices-page .line-item-row .col-price-wrapper::before {
    content: 'Price';
    font-size: 0.7rem;
    color: var(--text-muted);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    white-space: nowrap;
    min-width: 2.5rem;
  }

  .invoices-page .line-item-row input.col-qty,
  .invoices-page .line-item-row input.col-price {
    flex: 1 1;
    text-align: left;
    min-height: 44px;
  }

  /* Amount + remove button row */
  .invoices-page .line-item-row .item-amount {
    /* Shown inline with remove button */
    font-size: 0.9rem;
  }

  .invoices-page .line-item-row .remove-item-btn {
    position: absolute;
    top: 0.99rem;
    right: 0.75rem;
    min-width: 36px;
    min-height: 36px;
    padding: 0.375rem;
  }

  .invoices-page .add-item-btn {
    min-height: 44px;
    padding: 0.75rem 1rem;
    width: 100%;
    justify-content: center;
  }

  /* ── Modals → bottom sheets ──────────────────────────────────────────────── */
  .invoices-page .modal-overlay {
    /* The overlay itself stays full-screen — no change needed */
    z-index: 1001;
  }

  .invoices-page .modal-container {
    position: fixed;
    top: auto;
    bottom: unset;
    left: 50%;
    right: 0;
    width: 100%;
    max-width: 100%;
    /* Undo the desktop centered-translate */
    transform: none;
    border-radius: 16px 16px 0 0;
    max-height: 92vh;
    display: flex;
    flex-direction: column;
    animation: invoice-modal-up 0.25s ease;
    padding-bottom: env(safe-area-inset-bottom);
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.2);
    z-index: 1002;
    transform: translate(-50%);
    max-width: 90% !important;
  }

  @keyframes invoice-modal-up {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }

  /* Drag handle for modals */
  .invoices-page .modal-container::before {
    content: '';
    display: block;
    width: 40px;
    height: 4px;
    background: var(--border-color);
    border-radius: 2px;
    margin: 0.625rem auto 0;
  }

  .invoices-page .modal-body {
    overflow-y: auto;
    flex: 1 1;
    padding: 1rem 1.25rem;
  }

  /* Modal footer: full-width stacked buttons */
  .invoices-page .modal-footer {
    flex-direction: column-reverse;
    gap: 0.5rem;
    padding: 0.875rem 1.25rem;
  }

  .invoices-page .modal-footer .btn-outline,
  .invoices-page .modal-footer .btn-danger,
  .invoices-page .modal-footer .btn-primary {
    width: 100%;
    min-height: 44px;
    justify-content: center;
    text-align: center;
  }

  /* Modal inputs & selects: full width, 44px tap target */
  .invoices-page .modal-select,
  .invoices-page .modal-input {
    min-height: 44px;
    width: 100%;
    box-sizing: border-box;
  }
}

/* ==========================================================================
   Invoice stat cards
   The same card the transactions summary and the balance page use, on the same
   rhythm: tinted icon tile, label, one figure, one qualifier.
   ========================================================================== */
.inv-stats {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}
.inv-stats .stat-card { padding: 12px 14px; gap: 5px; }
.inv-stats .stat-card__icon { width: 30px; height: 30px; border-radius: 9px; }
.inv-stats .stat-card__icon svg { width: 16px; height: 16px; }
.inv-stats .stat-card__label { font-size: 12px; }
/* Outstanding totals can run to eleven digits, so the figure is allowed to
   shrink rather than overflow its card. */
.inv-stats .stat-card__value { font-size: clamp(16px, 1.45vw, 20px); }
.inv-stats .stat-card__sub { font-size: 11px; }

@media (max-width: 1100px) { .inv-stats { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
@media (max-width: 560px) { .inv-stats { grid-template-columns: minmax(0, 1fr); } }
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Invoices.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;;AAEF;4CAC4C;AAC5C;EACE,aAAa;AACf;;AAEA;;6EAE6E;AAC7E;EACE,wEAAwE;EACxE;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;;6EAE6E;AAC7E;EACE,mCAAmC;EACnC;IACE,qCAAqC;EACvC;;EAEA,8BAA8B;EAC9B;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA;;6EAE6E;AAC7E;EACE;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA,8EAA8E;EAC9E;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA,8EAA8E;EAC9E;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,6EAA6E;EAC7E;IACE,qCAAqC;IACrC,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,8EAA8E;EAC9E;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,uBAAuB;EACzB;;EAEA,8EAA8E;EAC9E;IACE,uBAAuB;IACvB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA,0FAA0F;EAC1F;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA,4BAA4B;EAC5B;IACE,6BAA6B;IAC7B,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,cAAc;IACd,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,uDAAuD;EACvD;IACE,6BAA6B;IAC7B,qCAAqC;IACrC,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,+EAA+E;EAC/E;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,QAAQ;EACV;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA,+EAA+E;EAC/E;IACE,SAAS;IACT,SAAS;IACT,QAAQ;IACR,OAAO;IACP,UAAU;IACV,YAAY;IACZ,wBAAwB;IACxB,0CAA0C;IAC1C,0CAA0C;IAC1C,2CAA2C;IAC3C,cAAc;EAChB;EACA;IACE,WAAW;EACb;;EAEA;IACE,OAAO,2BAA2B,EAAE;IACpC,OAAO,wBAAwB,EAAE;EACnC;;EAEA,2BAA2B;EAC3B;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA,mDAAmD;EACnD;IACE,sBAAsB;IACtB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,SAAO;IACP,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA,mDAAmD;EACnD;IACE,eAAe;IACf,WAAW;IACX,WAAW;EACb;;EAEA,sEAAsE;EACtE;IACE,aAAa;EACf;;EAEA,mEAAmE;EACnE;IACE,aAAa;EACf;;EAEA,qCAAqC;EACrC;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,wDAAwD;EAC1D;;EAEA,kDAAkD;EAClD;IACE,eAAe;EACjB;;EAEA,6BAA6B;EAC7B;IACE,0BAA0B;IAC1B,MAAM;EACR;;EAEA,8CAA8C;EAC9C;;;IAGE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;EACf;;EAEA;IACE,gDAAgD;IAChD,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;EACb;;EAEA,kCAAkC;EAClC;IACE,cAAc;IACd,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;;IAEE,SAAO;IACP,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,+BAA+B;EAC/B;IACE,oCAAoC;IACpC,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;IACX,uBAAuB;EACzB;;EAEA,+EAA+E;EAC/E;IACE,4DAA4D;IAC5D,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,aAAa;IACb,SAAS;IACT,QAAQ;IACR,WAAW;IACX,eAAe;IACf,wCAAwC;IACxC,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,sCAAsC;IACtC,2CAA2C;IAC3C,0CAA0C;IAC1C,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;EAC3B;;EAEA;IACE,OAAO,2BAA2B,EAAE;IACpC,OAAO,wBAAwB,EAAE;EACnC;;EAEA,2BAA2B;EAC3B;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,SAAO;IACP,qBAAqB;EACvB;;EAEA,6CAA6C;EAC7C;IACE,8BAA8B;IAC9B,WAAW;IACX,yBAAyB;EAC3B;;EAEA;;;IAGE,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,wDAAwD;EACxD;;IAEE,gBAAgB;IAChB,WAAW;IACX,sBAAsB;EACxB;AACF;;AAEA;;;;+EAI+E;AAC/E;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;AACA,wBAAwB,kBAAkB,EAAE,QAAQ,EAAE;AACtD,8BAA8B,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAC7E,kCAAkC,WAAW,EAAE,YAAY,EAAE;AAC7D,+BAA+B,eAAe,EAAE;AAChD;0CAC0C;AAC1C,+BAA+B,oCAAoC,EAAE;AACrE,6BAA6B,eAAe,EAAE;;AAE9C,6BAA6B,aAAa,gDAAgD,EAAE,EAAE;AAC9F,4BAA4B,aAAa,qCAAqC,EAAE,EAAE","sourcesContent":["/*\n * Invoices.css — responsive overrides for src/pages/Invoices.jsx\n * Loads AFTER index.css (imported as first CSS in Invoices.jsx) so wins at equal specificity.\n *\n * Breakpoints (project standard — do not invent others):\n *   mobile  : max-width  576px\n *   tablet  : 577px – 991px\n *   laptop  : 992px – 1280px\n *   desktop : min-width 1281px\n *\n * Desktop behaviour is UNCHANGED — all rules live inside max-width media queries.\n */\n\n/* Mobile card list is always hidden unless we are on mobile.\n   The table is always visible on tablet+. */\n.invoices-page .invoice-cards-mobile {\n  display: none;\n}\n\n/* ===========================================================================\n * LAPTOP (≤1280px): drawer full-width, hide preview pane\n * ======================================================================== */\n@media (max-width: 1280px) {\n  /* Drawer already collapses at 1024px in inline styles; reinforce here */\n  .invoices-page .invoice-drawer {\n    width: 100%;\n  }\n\n  .invoices-page .drawer-preview {\n    display: block;\n    width: 100%;\n  }\n}\n\n/* ===========================================================================\n * TABLET (577px – 991px): gentle reflow\n * ======================================================================== */\n@media (max-width: 991px) {\n  /* Stats row: 3 columns on tablet */\n  .invoices-page .stats-row {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  /* Drawer header: allow wrap */\n  .invoices-page .drawer-header {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .invoices-page .drawer-header-right {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n}\n\n/* ===========================================================================\n * MOBILE (≤576px): full app-like treatment\n * ======================================================================== */\n@media (max-width: 576px) {\n  .invoices-page .drawer-preview{\n    overflow: scroll;\n  }\n  .drawer-content{\n    display: inline-block;\n    overflow: scroll;\n  }\n\n  /* ── Page wrapper ───────────────────────────────────────────────────────── */\n  .invoices-page {\n    min-width: 0;\n    overflow-x: hidden;\n  }\n\n  /* ── Page header: stack title + button ──────────────────────────────────── */\n  .invoices-page .page-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .invoices-page .page-header h1 {\n    font-size: 1.25rem;\n  }\n\n  .invoices-page .page-header .btn-primary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n    padding: 0.625rem 1rem;\n  }\n\n  /* ── Stats row: 2 columns on mobile ────────────────────────────────────── */\n  .invoices-page .stats-row {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.625rem;\n    margin-bottom: 1rem;\n  }\n\n  .invoices-page .stat-item {\n    padding: 0.875rem 1rem;\n  }\n\n  .invoices-page .stat-value {\n    font-size: 1.25rem;\n  }\n\n  /* ── Table toolbar: wrap, full-width search ─────────────────────────────── */\n  .invoices-page .table-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.625rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .invoices-page .search-box {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .invoices-page .search-box input {\n    width: 100%;\n    min-height: 44px;\n    box-sizing: border-box;\n  }\n\n  .invoices-page .toolbar-actions {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  .invoices-page .btn-toolbar {\n    min-height: 44px;\n    flex: 1;\n    justify-content: center;\n  }\n\n  .invoices-page .btn-clear-filters {\n    min-height: 44px;\n    width: 100%;\n    justify-content: center;\n  }\n\n  /* ── Invoices table: hide, show card list ───────────────────────────────── */\n  .invoices-page .invoices-table-card {\n    background: transparent;\n    border: none;\n    padding: 0;\n  }\n\n  .invoices-page .table-container {\n    overflow-x: visible;\n  }\n\n  .invoices-page .invoices-data-table {\n    display: none;\n  }\n\n  /* Card list container — shown on mobile, hidden on larger screens (see base rule above) */\n  .invoices-page .invoice-cards-mobile {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  /* Individual invoice card */\n  .invoices-page .invoice-card-mobile {\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 12px;\n    padding: 1rem;\n    cursor: pointer;\n    transition: background-color 0.15s;\n    display: flex;\n    flex-direction: column;\n    gap: 0.625rem;\n  }\n\n  .invoices-page .invoice-card-mobile:active {\n    background: var(--bg-secondary);\n  }\n\n  .invoices-page .invoice-card-mobile-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n\n  .invoices-page .invoice-card-mobile-id {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-weight: 600;\n    font-size: 0.875rem;\n    color: var(--text-primary);\n    min-width: 0;\n  }\n\n  .invoices-page .invoice-card-mobile-id svg {\n    flex-shrink: 0;\n    color: var(--accent-primary);\n  }\n\n  .invoices-page .invoice-card-mobile-amount {\n    font-weight: 700;\n    font-size: 1rem;\n    color: var(--text-primary);\n    flex-shrink: 0;\n  }\n\n  .invoices-page .invoice-card-mobile-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.8rem;\n  }\n\n  .invoices-page .invoice-card-mobile-label {\n    font-size: 0.7rem;\n    color: var(--text-muted);\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    flex-shrink: 0;\n  }\n\n  .invoices-page .invoice-card-mobile-value {\n    color: var(--text-secondary);\n    text-align: right;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .invoices-page .invoice-card-mobile-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-top: 0.5rem;\n    border-top: 1px solid var(--border-color);\n    gap: 0.5rem;\n  }\n\n  .invoices-page .invoice-card-mobile-actions {\n    display: flex;\n    gap: 0.5rem;\n  }\n\n  .invoices-page .invoice-card-mobile-actions .action-icon-btn {\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Empty / loading states within mobile cards wrapper */\n  .invoices-page .invoice-mobile-empty {\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 12px;\n    padding: 3rem 1.5rem;\n    text-align: center;\n    color: var(--text-muted);\n  }\n\n  .invoices-page .invoice-mobile-empty p {\n    margin: 0.75rem 0 1rem;\n  }\n\n  .invoices-page .invoice-mobile-empty .btn-primary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* ── Pagination: stack info and controls ─────────────────────────────────── */\n  .invoices-page .pagination-container {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n    padding: 0.75rem 0;\n  }\n\n  .invoices-page .pagination-info {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    font-size: 0.8rem;\n    justify-content: space-between;\n  }\n\n  .invoices-page .page-size-select {\n    min-height: 44px;\n  }\n\n  .invoices-page .pagination-controls {\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 4px;\n  }\n\n  .invoices-page .pagination-btn,\n  .invoices-page .page-number {\n    min-width: 44px;\n    min-height: 44px;\n  }\n\n  /* ── Create Invoice Drawer → bottom sheet ────────────────────────────────── */\n  .invoices-page .invoice-drawer {\n    top: 20px;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    width: 90%;\n    height: 95vh;\n    border-radius: 16px 16px;\n    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.2);\n    animation: invoice-drawer-up 0.3s ease-out;\n    padding-bottom: env(safe-area-inset-bottom);\n    margin: 0 auto;\n  }\n  .drawer-header-right .btn-outline {\n    width: 100%;\n  }\n\n  @keyframes invoice-drawer-up {\n    from { transform: translateY(100%); }\n    to   { transform: translateY(0); }\n  }\n\n  /* Drag handle affordance */\n  .invoices-page .invoice-drawer::before {\n    content: '';\n    display: block;\n    width: 40px;\n    height: 4px;\n    background: var(--border-color);\n    border-radius: 2px;\n    margin: 0.625rem auto 0;\n  }\n\n  /* Drawer header: compress + wrap on small screen */\n  .invoices-page .drawer-header {\n    padding: 0.625rem 1rem;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .invoices-page .drawer-header-left {\n    gap: 0.625rem;\n    flex: 1;\n    min-width: 0;\n  }\n\n  .invoices-page .drawer-title-section h2 {\n    font-size: 0.9rem;\n  }\n\n  /* Header right: wrap into second row when needed */\n  .invoices-page .drawer-header-right {\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  /* Show preview button hidden on mobile (preview pane always hidden) */\n  .invoices-page .drawer-header-right .btn-outline:first-of-type {\n    display: none;\n  }\n\n  /* Maximize button hidden on mobile (not useful for bottom sheet) */\n  .invoices-page .btn-icon-outline {\n    display: none;\n  }\n\n  /* Create Invoice button full-width */\n  .invoices-page .drawer-header-right .btn-primary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* Form scroll padding */\n  .invoices-page .form-scroll {\n    padding: 1rem;\n    padding-bottom: calc(1rem + env(safe-area-inset-bottom));\n  }\n\n  /* Section content: reduce left indent on mobile */\n  .invoices-page .section-content {\n    padding-left: 0;\n  }\n\n  /* Form rows: single column */\n  .invoices-page .form-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n\n  /* Inputs full-width with proper tap targets */\n  .invoices-page .form-group input,\n  .invoices-page .form-group select,\n  .invoices-page .form-group textarea {\n    width: 100%;\n    min-height: 44px;\n    box-sizing: border-box;\n  }\n\n  .invoices-page .form-group textarea {\n    min-height: auto;\n  }\n\n  /* ── Line items: stack each item as a card ─────────────────────────────── */\n  .invoices-page .line-items-header {\n    display: none;\n  }\n\n  .invoices-page .line-item-row {\n    /* Switch from 5-column grid to stacked layout */\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 0.75rem;\n    border-top: 1px solid var(--border-color);\n    position: relative;\n  }\n\n  .invoices-page .line-item-row input.col-description {\n    width: 100%;\n    font-size: 0.9rem;\n    padding: 0.5rem 2.75rem 0.5rem 0.5rem;\n    min-height: 44px;\n  }\n\n  .invoices-page .line-item-row .col-qty-wrapper,\n  .invoices-page .line-item-row .col-price-wrapper {\n    flex-direction: row;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  /* Label before qty/price inputs */\n  .invoices-page .line-item-row .col-qty-wrapper::before {\n    content: 'Qty';\n    font-size: 0.7rem;\n    color: var(--text-muted);\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    white-space: nowrap;\n    min-width: 2.5rem;\n  }\n\n  .invoices-page .line-item-row .col-price-wrapper::before {\n    content: 'Price';\n    font-size: 0.7rem;\n    color: var(--text-muted);\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    white-space: nowrap;\n    min-width: 2.5rem;\n  }\n\n  .invoices-page .line-item-row input.col-qty,\n  .invoices-page .line-item-row input.col-price {\n    flex: 1;\n    text-align: left;\n    min-height: 44px;\n  }\n\n  /* Amount + remove button row */\n  .invoices-page .line-item-row .item-amount {\n    /* Shown inline with remove button */\n    font-size: 0.9rem;\n  }\n\n  .invoices-page .line-item-row .remove-item-btn {\n    position: absolute;\n    top: 0.99rem;\n    right: 0.75rem;\n    min-width: 36px;\n    min-height: 36px;\n    padding: 0.375rem;\n  }\n\n  .invoices-page .add-item-btn {\n    min-height: 44px;\n    padding: 0.75rem 1rem;\n    width: 100%;\n    justify-content: center;\n  }\n\n  /* ── Modals → bottom sheets ──────────────────────────────────────────────── */\n  .invoices-page .modal-overlay {\n    /* The overlay itself stays full-screen — no change needed */\n    z-index: 1001;\n  }\n\n  .invoices-page .modal-container {\n    position: fixed;\n    top: auto;\n    bottom: unset;\n    left: 50%;\n    right: 0;\n    width: 100%;\n    max-width: 100%;\n    /* Undo the desktop centered-translate */\n    transform: none;\n    border-radius: 16px 16px 0 0;\n    max-height: 92vh;\n    display: flex;\n    flex-direction: column;\n    animation: invoice-modal-up 0.25s ease;\n    padding-bottom: env(safe-area-inset-bottom);\n    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.2);\n    z-index: 1002;\n    transform: translate(-50%);\n    max-width: 90% !important;\n  }\n\n  @keyframes invoice-modal-up {\n    from { transform: translateY(100%); }\n    to   { transform: translateY(0); }\n  }\n\n  /* Drag handle for modals */\n  .invoices-page .modal-container::before {\n    content: '';\n    display: block;\n    width: 40px;\n    height: 4px;\n    background: var(--border-color);\n    border-radius: 2px;\n    margin: 0.625rem auto 0;\n  }\n\n  .invoices-page .modal-body {\n    overflow-y: auto;\n    flex: 1;\n    padding: 1rem 1.25rem;\n  }\n\n  /* Modal footer: full-width stacked buttons */\n  .invoices-page .modal-footer {\n    flex-direction: column-reverse;\n    gap: 0.5rem;\n    padding: 0.875rem 1.25rem;\n  }\n\n  .invoices-page .modal-footer .btn-outline,\n  .invoices-page .modal-footer .btn-danger,\n  .invoices-page .modal-footer .btn-primary {\n    width: 100%;\n    min-height: 44px;\n    justify-content: center;\n    text-align: center;\n  }\n\n  /* Modal inputs & selects: full width, 44px tap target */\n  .invoices-page .modal-select,\n  .invoices-page .modal-input {\n    min-height: 44px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n}\n\n/* ==========================================================================\n   Invoice stat cards\n   The same card the transactions summary and the balance page use, on the same\n   rhythm: tinted icon tile, label, one figure, one qualifier.\n   ========================================================================== */\n.inv-stats {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 14px;\n}\n.inv-stats .stat-card { padding: 12px 14px; gap: 5px; }\n.inv-stats .stat-card__icon { width: 30px; height: 30px; border-radius: 9px; }\n.inv-stats .stat-card__icon svg { width: 16px; height: 16px; }\n.inv-stats .stat-card__label { font-size: 12px; }\n/* Outstanding totals can run to eleven digits, so the figure is allowed to\n   shrink rather than overflow its card. */\n.inv-stats .stat-card__value { font-size: clamp(16px, 1.45vw, 20px); }\n.inv-stats .stat-card__sub { font-size: 11px; }\n\n@media (max-width: 1100px) { .inv-stats { grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n@media (max-width: 560px) { .inv-stats { grid-template-columns: minmax(0, 1fr); } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
